export default __webpack_public_path__ + "static/media/regreenbus_info_visual_02.18a5ffd6.png";